import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { RECORDINGS } from '../../constants';
class RibbonRecording extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.unFocusHandler = props.unFocusHandler;
        this.onClickHandler = props.onClickHandler ? props.onClickHandler : null;
        this.typeRender = props.typeRender ? props.typeRender : null;
        this.onFocus = this.onFocus.bind(this);
        this.ribbonIndex = props.index;
        this.api = props.api;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.isModalRecordSerie = props.code === "series";
    }

    onFocus(event) {
        if (typeof this.focusHandler === 'function') {
            this.focusHandler(event);
        }
    }

    clickHandler(data) {
        this.onClickHandler && this.onClickHandler(data);
    }

    getEventId(event) {
        return event.event_alf_id || event.event_id
    }

    render() {
        return (
            <div className="ribbon-items ribbon-recordings">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const key = Math.random() * 10;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };
                    const [
                        {item: firstItem} = {},
                        {item: secondItem} = {}
                    ] = this.visibleItems;

                    return (
                        <Card
                            cover={node_item.cover}
                            unFocusHandler={this.unFocusHandler}
                            focusHandler={this.focusHandler}
                            id={ this.isModalRecordSerie ? this.getEventId(node_item) : index + 1}
                            ribbonId= {this.ribbonId}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id}
                            typeRender={this.typeRender}
                            onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon);
                                e.preventDefault();
                                e.stopPropagation();
                                this.clickHandler(node_item);
                            }}
                            hideTitles={this.props.hideTitles}
                            isRecentActivity={this.props.isRecentActivity}
                            label={node_item.label}
                            type={RECORDINGS}
                            title={node_item.title}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={this.isModalRecordSerie && secondItem
                                ? `#link-${this.getEventId(secondItem)}`
                                : `#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={this.isModalRecordSerie && firstItem
                                ? `#link-${this.getEventId(firstItem)}`
                                : `#${this.ribbonId} ${this.focusSettings.selector}`}
                            setMetricsEvent={this.setMetricsEvent}
                            sibling={node_item.sibling}
                            hideInnerTitle={this.hideInnerTitle}
                            keyDownHandler={this.keyDownHandler}
                            is_music={false}
                            api={this.api}
                            ribbonName={this.ribbonName}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonRecording;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonRecordings/index.jsx